export default function accordion(){
  $('.accordion .item').click(function(e){
    $(this).find('.title').toggleClass('active')
    $(this).find('.content').toggleClass('active')
    e.stopImmediatePropagation()
  })
}